import React from 'react';
import { Document, Page, View, StyleSheet } from '@react-pdf/renderer';
import { PDF_THEMES, DEFAULT_THEME } from '../themes';
import PdfHeader from '../components/PdfHeader';
import PdfFooter from '../components/PdfFooter';
import PdfFilterLine from '../components/PdfFilterLine';
import PdfSummaryCards from '../components/PdfSummaryCards';
import { PdfTableHead, PdfTableRow, PdfTableFoot } from '../components/PdfTable';
import { fmtINR, fmtDate } from '../pdfUtils';

const s = StyleSheet.create({
  page:    { fontFamily: 'NotoSans', paddingBottom: 60 },
  content: { marginHorizontal: 40, marginTop: 12 },
});

const COLS = [
  { label: 'Date',        flex: 0.9 },
  { label: 'Receipt No',  flex: 1 },
  { label: 'Category',    flex: 1.6 },
  { label: 'Grams',       flex: 0.8, align: 'right' },
  { label: 'Purity',      flex: 0.8, align: 'right' },
  { label: 'Rate (â‚¹/g)',  flex: 1,   align: 'right' },
  { label: 'Value (â‚¹)',   flex: 1.1, align: 'right' },
];

export default function GoldRegisterDocument({ data, theme: themeKey, orientation, sections, filters }) {
  const t = PDF_THEMES[themeKey] || PDF_THEMES[DEFAULT_THEME];
  const receipts = Array.isArray(data.receipts) ? data.receipts : [];
  const totGrams = data.totalGrams ?? receipts.reduce((s, r) => s + Number(r.goldGrams || 0), 0);
  const totINR   = data.totalInr   ?? receipts.reduce((s, r) => s + Number(r.amountInr || 0), 0);

  return (
    <Document>
      <Page size="A4" orientation={orientation || 'landscape'} style={[s.page, { backgroundColor: t.white }]}>
        {sections.header && <PdfHeader derasar={data.derasar} reportTitle="Gold Register" theme={t} />}
        <View style={s.content}>
          {sections.filterLine && <PdfFilterLine filters={filters} theme={t} />}
          {sections.summaryCards && (
            <PdfSummaryCards theme={t} items={[
              { label: 'Total Entries', value: String(receipts.length), color: t.primary },
              { label: 'Total Grams',   value: `${Number(totGrams).toFixed(3)} g`, color: t.statusAmber },
              { label: 'Total Value',   value: fmtINR(totINR),          color: t.body  },
            ]} />
          )}
          <PdfTableHead cols={COLS} theme={t} />
          {receipts.map((row, i) => (
            <PdfTableRow key={i} cols={COLS} index={i} theme={t}
              values={[
                fmtDate(row.date || row.receiptDate),
                row.receiptNo || 'â€”',
                row.category || row.donationCategory?.name || 'â€”',
                `${Number(row.goldGrams || 0).toFixed(3)} g`,
                row.goldPurity ? `${row.goldPurity}K` : 'â€”',
                fmtINR(row.valuationRate),
                fmtINR(row.amountInr),
              ]}
            />
          ))}
          <PdfTableFoot cols={COLS}
            values={['', `${receipts.length} entries`, '', `${Number(totGrams).toFixed(3)} g`, '', '', fmtINR(totINR)]}
            theme={t}
          />
        </View>
        {sections.footer && <PdfFooter theme={t} />}
      </Page>
    </Document>
  );
}



